import { Info, TextT } from "@phosphor-icons/react";
import { Banner } from "@replicate/ui";
import type { Version } from "../../types";

export function DestinationPreview({
  owner,
  avatar,
  version,
}: {
  owner: string;
  avatar: string;
  version: Version;
}) {
  return (
    <div className="space-y-2 flex flex-col pb-4">
      <label className="text-r8-base font-mono">
        <div className="flex items-center gap-1.5">
          <TextT />
          destination
        </div>
      </label>
      <div className="flex items-center gap-2 p-2 border bg-r8-gray-2">
        <img
          className="w-6 h-6 rounded-full flex-shrink-0"
          alt={`Avatar for ${owner}`}
          src={avatar}
        />
        <span>{owner}</span>
        <span>/</span>
        <span>{version._extras.model.name}</span>
      </div>
      <Banner
        icon={<Info />}
        severity="info"
        condensed
        description={
          <p>
            The trained model will be added to Replicate as a new version of the{" "}
            {version._extras.model.owner}/{version._extras.model.name} model.
          </p>
        }
      />
    </div>
  );
}
